<mat-toolbar class="companiesbg">

    <div>
        <button mat-icon-button *ngIf="!pageConfig.edit" (click)="goBack()">
            <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
        <a mat-icon-button (click)="displayItem()" *ngIf="pageConfig.edit">
            <mat-icon>keyboard_arrow_left</mat-icon>
        </a>
        <div class="title">
            <mat-icon>{{GLOBAL.ICONS.BROKER}}</mat-icon>
            <ng-container>
                B{{item.values.ref}}: {{item.values.synaps.contactBrokerObjList ? item.values.synaps.contactBrokerObjList.fullname : (item.values.synaps.companyBrokerObjList ? item.values.synaps.companyBrokerObjList.displayname : 'No contact...')}} - {{item.values.status | param:'brokerStatus'}} Broker
            </ng-container>
        </div>
    </div>
    <div>
        <profile></profile>
        <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="logs()">
                <mat-icon>{{GLOBAL.ICONS.LOGS}}</mat-icon>
                <span>Logs</span>
            </button>
        </mat-menu>
    </div>
</mat-toolbar>
<div class="toolbartop"></div>


<!------------------------------ READ MODE  ----------------------------------------->

<div class="mdc-layout-grid brokerPage" *ngIf="!pageConfig.edit">
    <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell--span-4" *ngIf="item.values.synaps.contactBrokerObj?.$key">
             <app-contact-tab [key]="item.values.synaps.contactBrokerObj.$key"
                [options]="{}">
            </app-contact-tab>
        </div>
        <div class="mdc-layout-grid__cell--span-4" *ngIf="item.values.synaps.companyBrokerObj?.$key">
            <app-company-tab [key]="item.values.synaps.companyBrokerObj.$key">
            </app-company-tab>
        </div>
        <div class="mdc-layout-grid__cell--span-4">
            <div>
                <mat-card class="full">
                    <mat-list *ngIf="pageConfig.loaded">
                        <!-- <mat-list-item>
                            <mat-icon matListIcon>
                                {{GLOBAL.ICONS.STATUS}}</mat-icon>
                            <h3 matLine> {{item.values.status | param:'brokerStatus'}}</h3>
                        </mat-list-item> -->
                        <mat-list-item>
                            <mat-icon matListIcon>
                                {{GLOBAL.ICONS.PERCENT}}</mat-icon>
                            <h3 matLine> {{item.values.fee}}%</h3>
                        </mat-list-item>
                        <mat-list-item>
                            <mat-icon matListIcon>
                                {{GLOBAL.ICONS.DATE}}</mat-icon>
                            <h3 matLine> Start: {{item.values.dateStart | date:'dd MMM yyyy'}}</h3>
                        </mat-list-item>
                        <mat-list-item *ngIf="item.values.dateEnd && item.values.status == 'inactive'">
                            <mat-icon matListIcon>
                                {{GLOBAL.ICONS.DATE}}</mat-icon>
                            <h3 matLine> End: {{item.values.dateEnd | date:'dd MMM yyyy'}}</h3>
                        </mat-list-item>

                    </mat-list>
                </mat-card>
            </div>
        </div>

    </div>
</div>


<!------------------------------ EDIT MODE  ----------------------------------------->


<div class="contactPage" *ngIf="pageConfig.edit">

    <div class="mdc-layout-grid">
        <div class="mdc-layout-grid__inner">
            <div class="mdc-layout-grid__cell--span-6">
                <form-builder [item]="item" [values]="item.values" section="main" [edit]="true"></form-builder>

            </div>
        </div>
    </div>

</div>


<mat-spinner [strokeWidth]="5" class="fixed" *ngIf="!(pageConfig.loaded || new)"></mat-spinner>

<!------------------------------ BUTTONS  ----------------------------------------->

<!-- NEW -->
<button *ngIf="new" mat-fab class="bottom-right pfixed" [disabled]="!item.valid || !item.modified || item.saving"
    (click)="saveNewItem()">
    <mat-icon matListIcon>check</mat-icon>
</button>
<!-- EDIT -->
<button *ngIf="!new && !pageConfig.edit" mat-fab class="bottom-right pfixed" (click)="editItem()">
    <mat-icon matListIcon>edit</mat-icon>
</button>
<!-- SAVE -->
<button *ngIf="!new && pageConfig.edit" mat-fab class="bottom-right pfixed"
    [disabled]="!item.valid  || !item.modified || item.saving" (click)="saveItem(false)">
    <mat-icon matListIcon>check</mat-icon>
</button>
<!-- CANCEL -->
<button mat-fab *ngIf="!new && pageConfig.edit" class="bottom-right pfixed p2" [disabled]="item.saving" color="basic"
    (click)="cancelEdit(true)">
    <mat-icon matListIcon>close</mat-icon>
</button>

<!-- DELETE -->
<button *ngIf="!new && !pageConfig.edit && isRole('admin')" mat-fab class="bottom-left pfixed" color="basic"
    (click)="db.deleteItem(item)">
    <mat-icon matListIcon>delete</mat-icon>
</button>